import styled from "styled-components";

export const GamesOpenSessionRecordContentContainerDefaultBox = styled.div`
    --open-session-record-content-padding: 2px;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    padding: var(--open-session-record-content-padding);
    
`